module.exports = __webpack_public_path__ + "img/chevron-left.82ef2d57.svg";